<template>
  <div class="member-container">
    <el-popover trigger="click" @hide="hide" @show="show">
      <div slot="reference" class="btn btn-active">
        <i class="icon iconfont iconicon_participant"></i>
        成员筛选
        <span class="num">{{ number ? number : '' }}</span>
      </div>

      <div class="member-content" @click.prevent="handleClickDoc($event)">
        <div class="top">
          <p class="tit">成员筛选</p>
          <span class="btn text-btn-active" @click="handleReset">重置</span>
        </div>

        <div class="item">
          <p class="tit">执行人</p>
          <el-popover
            trigger="click"
            :tabindex="0"
            v-model="executorShowPanel"
            @show="hanldeShow('participantShowPanel')"
          >
            <Member-popover
              v-if="executorShowPanel"
              ref="executors"
              :projectId="projectId"
              :chosMembers="executors"
              @handleMembersChange="handleMembersChange($event, 'executors')"
            ></Member-popover>

            <div slot="reference" class="members-input">
              <p v-if="!executors.length" class="tis">请选择</p>
              <ul class="members-list">
                <li v-for="item in (executors.slice(0, 4))" :key="item.uid">
                  {{ item.realname }}
                  <i class="icon iconfont iconicon_close1 btn-active" @click.stop="handleDel(item, 'executors')"></i>
                </li>
              </ul>
              <i
                :class="{ 'showPanel': executorShowPanel }"
                class="icon iconfont iconicon_drop_down_arrow rota90"
              ></i>
            </div>
          </el-popover>
        </div>

        <div class="item">
          <p class="tit">参与人</p>
          <el-popover
            trigger="click"
            :tabindex="1"
            v-model="participantShowPanel"
            @show="hanldeShow('executorShowPanel')"
          >
            <Member-popover
              v-if="participantShowPanel"
              ref="participants"
              :projectId="projectId"
              :chosMembers="participants"
              @handleMembersChange="handleMembersChange($event, 'participants')"
            ></Member-popover>

            <div slot="reference" class="members-input">
              <p v-if="!participants.length" class="tis">请选择</p>
              <ul class="members-list">
                <li v-for="item in (participants.slice(0, 4))" :key="item.uid">
                  {{ item.realname }}
                  <i class="icon iconfont iconicon_close1 btn-active" @click.stop="handleDel(item, 'participants')"></i>
                </li>
              </ul>
              <i
                :class="{ 'showPanel': participantShowPanel }"
                class="icon iconfont iconicon_drop_down_arrow rota90"
              ></i>
            </div>
          </el-popover>
        </div>

      </div>
    </el-popover>
  </div>
</template>

<script>
import MemberPopover from './memberPopover.vue'

export default {
  components: {
    MemberPopover
  },
  props: {
    projectId: {
      type: [Number, String],
      default: 0
    },
  },
  computed: {
    number() {
      const _num1 = this.executors.length ? 1 : 0
      const _num2 = this.participants.length ? 1 : 0
      return _num1 + _num2
    }
  },
  data() {
    return {
      list: [],
      executors: [], // 已选执行人
      executorShowPanel: false, // 执行人选择框是否展开
      participants: [], // 已选参与人
      participantShowPanel: false, // 参与人选择框是否展开
      isChange: false
    }
  },
  watch: {

  },
  mounted() {

    // console.log(this.taskList, 111)
  },
  methods: {
    // 成员变化
    handleMembersChange(val, type) {
      this[type] = val

      // type值区分成员类型 'executors'为执行人, 'participants'为参与人
      // val值为成员组成的数组
      this.isChange = true
      this.$emit('handleMembersChange', type, val)
      this.$emit('change', {executors: this.executors, participants: this.participants})
    },
    handleDel(data, type) {
      const _index = this[type].findIndex(item => item.uid === data.uid)
      if (_index !== -1) {
        this[type].splice(_index, 1);
      }
      this.isChange = true
      this.$emit('handleMembersChange', type, this[type])
      this.$emit('change', {executors: this.executors, participants: this.participants})
    },
    // 重置
    handleReset() {
      this.executors = []
      this.participants = []
      this.isChange = true
      this.$emit('handleMembersClear')
      this.$emit('change', {executors: this.executors, participants: this.participants})
    },
    show() {
      this.isChange = false
    },
    hide() {
      if(this.isChange) {
        this.$emit('hide', {executors: this.executors, participants: this.participants})
      }
    },
    // 点击其他区域关闭浮窗
    handleClickDoc(event) {
      const _className = event.target.className
      const _arr = ['members-input', 'members-list', 'tis', 'icon iconfont iconicon_drop_down_arrow rota90 showPanel']
      if (!~_arr.indexOf(_className)) {
        this.executorShowPanel = false
        this.participantShowPanel = false
      }
      // console.log(e.className, 111)
    },
    // 其中一个成员控件展开时，另外一个需隐藏
    hanldeShow(type) {
      this[type] = false
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.member-container {
  .btn {
    font-size: 14px;
    @include fontColorOpacity(.6);
    i {
      font-size: 14px;
    }
  }
}
.member-content {
  width: 380px;
  box-sizing: border-box;
  padding: 14px 16px 20px;
  border-radius: 4px;
  .top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    line-height: 22px;
    @include fontColorOpacity(.6);
  }
  .item {
    margin-top: 24px;
    .tit {
      font-size: 14px;
      line-height: 22px;
      @include fontColorOpacity(.8);
      margin-bottom: 8px;
    }
    .members-input {
      width: 100%;
      height: 40px;
      border-radius: 4px;
      border: 1px solid rgba(32, 32, 32, .16);
      position: relative;
      cursor: pointer;
      .tis {
        font-size: 14px;
        line-height: 40px;
        @include fontColorOpacity(.44);
        padding-left: 16px;
      }
      .rota90 {
        position: absolute;
        right: 6px;
        top: 0;
        line-height: 40px;
        transition: all .3s;
        @include fontColorOpacity(.4);
        &.showPanel {
          transform: rotate(-90deg) !important;
        }
      }
      .members-list {
        width: 100%;
        padding: 6px 0 6px 8px;
        box-sizing: border-box;
        display: flex;
        li {
          padding-left: 8px;
          border-radius: 4px;
          font-size: 14px;
          @include bgColorOpacity(.08);
          line-height: 28px;
          display: flex;
          align-items: center;
          margin-right: 3px;
          i {
            cursor: pointer;
            font-size: 12px;
            line-height: 12px;
            border-radius: 0 4px 4px 0;
          }
        }
      }
    }
  }
}
</style>
